// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"71":"19235315","226":"07d1d310","305":"7f597913","572":"f818ddab","935":"0a58acee"}[chunkId] + ".chunk.css";
};